import React from "react";
import type { RouteComponentProps } from "react-router-dom";

import Notification from "../notification";
import PageFooter from "../page_footer";
import PageHeader from "../page_header";
import PatientMenu from "../patient_menu";
import PatientsTasksList from "./patients_tasks_list";
import Tour from "./tour";

export default function PatientsTaskPageBody(props: RouteComponentProps) {
  return (
    <>
      <PageHeader />
      <Tour />
      <div className="container">
        <div className="page-container">
          <PatientMenu />
          <Notification />
          <PatientsTasksList {...{ ...props, tasks: true }} />
        </div>
        <PageFooter />
      </div>
    </>
  );
}
